import { Languages } from '../../../../../hooks';
import { request } from '../../../../../service/request';
import { ApiResponse, LikeStatus } from '../../../type';

export const thumpUp = (data: { id: number; likeStatus: LikeStatus }) =>
  request<ApiResponse<any>>({
    url: '/chat/thumbs/up',
    data,
    method: 'POST',
  });

export const addSuggestions = (data: {
  chatId: string;
  suType: string;
  suContent: string;
}) =>
  request<ApiResponse<any>>({
    url: '/suggestion/add',
    data,
    method: 'POST',
  });

export const getSuggestionType = (params: { lang: Languages }) =>
  request<ApiResponse<{ code: number; name: string }[]>>({
    url: '/enums/suggestionType',
    method: 'GET',
    params,
  });
